(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('NewBannerController', NewBannerController);

  /* ngInject */
  function NewBannerController($state, Flash, bannerService, formErrorsService, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.banner = {};
    vm.bannerForm = {};
    vm.createBanner = createBanner;
    vm.noop = function() {};

    function createBanner() {
      vm.clearFormErrors(vm.bannerForm);
      bannerService(sessionService.getAuthToken()).save(vm.banner, _createBannerSuccess, _createBannerFailure);
    }

    function _createBannerSuccess(_response) {
      Flash.create('success', 'Banner successfully created.');
      $state.go('application.compliance_framework.banners');
    }

    function _createBannerFailure(error) {
      Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.');
      vm.setFormErrors(vm.bannerForm, error);
    }
  }
})();
